/* Poofy — helpers partagés entre les sections produit (Section 2 "Bénéfice intro",
   Section 3 "Bénéfice features"). Évite de dupliquer ce code dans chaque section.
   Expose window.PoofyContent = { getIconSvg, dualColorTitle, ICON_PATHS } */
(function () {
  var ICON_PATHS = {
    palette: 'M12 21a9 9 0 0 1 0-18c4.97 0 9 3.58 9 8 0 2.21-1.93 4-4.5 4H15a2 2 0 0 0-1 3.75 1.3 1.3 0 0 1-1 2.25M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0-2 0M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0-2 0M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0-2 0',
    resize:  'M16 4h4v4M14 10l6-6M8 20H4v-4M4 20l6-6M16 20h4v-4M20 20l-6-6M8 4H4v4M4 4l6 6',
    droplet: 'M12 3c.13 1 .64 1.93 1.78 3C15.45 7.64 16 9.23 16 11a4 4 0 0 1-8 0c0-1.77.55-3.36 2.22-5C11.36 4.93 11.87 4 12 3z',
    package: 'M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3m0 9 8-4.5M12 12v9M4 7.5l8 4.5m4-2.25-8 4.5',
    sofa:    'M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2M5 11V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v5M6 19v2M18 19v2',
    box:     'M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3m0 9 8-4.5M12 12v9M4 7.5l8 4.5',
    shield:  'M12 3a12 12 0 0 0 8.5 3A12 12 0 0 1 12 21 12 12 0 0 1 3.5 6 12 12 0 0 0 12 3z',
    users:   'M5 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.85',
    book:    'M3 19a9 9 0 0 1 9 0 9 9 0 0 1 9 0M3 6a9 9 0 0 1 9 0 9 9 0 0 1 9 0M3 6v13M12 6v13M21 6v13',
    star:    'M12 17.75l-6.17 3.24 1.18-6.87-5-4.87 6.9-1L12 2l3.09 6.25 6.9 1-5 4.87 1.18 6.87z',
    check:   'M5 12l5 5L20 7'
  };

  function getIconSvg(text, size, color) {
    size = size || 20; color = color || '#C89B72';
    var t = (text || '').toLowerCase();
    /* Couverture élargie à partir d'un audit des phrases réellement utilisées
       sur le site (familles velours/extérieur/repose-pieds/XXL) — voir PLAN
       du round 3. Plus de fallback "check" générique : dernier recours = 'star'. */
    var n = /coul|teinte|nuance|gris|blanc|beige|noir|rouge|vert|bleu|orange|jaune|rose|terracotta|marine|moutarde|kaki|taupe/.test(t) ? 'palette'
          : /taille|format|dimension|xl|xxl|grand|gros|g.n.reu|spacieux|compact/.test(t) ? 'resize'
          : /entretien|nettoyer|laver|humide|fra.ch|rin.age|tache/.test(t) ? 'droplet'
          : /livr|assemblage|montage|r.ception|pr.t.*emploi/.test(t) ? 'package'
          : /confort|moelleux|doux|rembourrage|enveloppant|d.tente|repos|relaxa|assise|si.ge|cosy/.test(t) ? 'sofa'
          : /rangement|coffre|ranger|couvercle|stockage|polyvalent|double usage|multi.?usage|s.adapte/.test(t) ? 'box'
          : /durable|r.sistant|r.sistance|durabilit.|qualit.|premium|noble|solide|long.vit|imperm|ext.rieur|outdoor|anti.?uv|tissu|mati.re|velours|textur./.test(t) ? 'shield'
          : /famille|enfant|adulte|personnes/.test(t) ? 'users'
          : /lecture|livre|lire|session/.test(t) ? 'book'
          : /pr.sence|lumineux|lumineuse|sobre|.l.gan|raffinement|discr.tion|design|scandinave|moderne|chic|harmonieux|naturel|tendance/.test(t) ? 'star'
          : 'star';
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><path d="' + ICON_PATHS[n] + '"/></svg>';
  }

  function dualColorTitle(title) {
    var words = title.trim().replace(/\s+/g, ' ').split(' ');
    if (words.length <= 1) return title;
    var n = Math.min(3, words.length - 1);
    var split = words.length - n;
    return words.slice(0, split).join(' ') + ' <span class="poofy-title-accent">' + words.slice(split).join(' ') + '</span>';
  }

  function capParagraphs(containerEl, max) {
    max = max || 2;
    var seen = 0;
    Array.prototype.slice.call(containerEl.querySelectorAll('p')).forEach(function (p) {
      seen++;
      if (seen > max) p.parentNode.removeChild(p);
    });
  }

  function normalizeText(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  /* Sélectionne une image par mot-clé dans son texte alternatif (convention
     "Nom produit – Gamme – Type", ex. "... – Matière") plutôt que par position fixe :
     le nombre/ordre d'images varie d'un produit à l'autre, un index fixe pointe alors
     vers la mauvaise photo (vécu sur La Luna, 6 images au lieu de 4). Repli sur l'ancien
     index fixe si aucun alt ne matche (produits pas encore tagués avec ce mot-clé). */
  function pickImageByAlt(images, alts, keyword, fallbackIndex) {
    if (!images || !images.length) return '';
    if (alts && alts.length) {
      var kw = normalizeText(keyword);
      for (var i = 0; i < alts.length; i++) {
        if (normalizeText(alts[i]).indexOf(kw) > -1) return images[i] || '';
      }
    }
    return images[fallbackIndex] || images[0] || '';
  }

  window.PoofyContent = {
    ICON_PATHS: ICON_PATHS,
    getIconSvg: getIconSvg,
    dualColorTitle: dualColorTitle,
    capParagraphs: capParagraphs,
    pickImageByAlt: pickImageByAlt
  };
})();
